/** Dígitos de cada código TOTP (lo que muestran Google Authenticator, Authy, etc.). */
export const TOTP_DIGITS = 6;
/** Segundos que dura cada código (paso de tiempo del RFC 6238). */
export const TOTP_PERIOD_SECONDS = 30;
/**
 * Pasos de tolerancia hacia atrás y hacia adelante: acepta el código
 * anterior y el siguiente para absorber relojes de teléfono desfasados
 * (±30 s) sin abrir demasiado la ventana de ataque.
 */
export const TOTP_WINDOW_STEPS = 1;
/** Algoritmo HMAC del código, tal como se anuncia en el URI `otpauth://`. */
export const TOTP_ALGORITHM_LABEL = 'SHA1';
/** Bytes aleatorios del secreto (160 bits, lo que recomienda el RFC 4226 para HMAC-SHA1). */
export const TOTP_SECRET_BYTES = 20;
/** Patrón de un código TOTP: exactamente seis dígitos. */
export const TOTP_CODE_PATTERN = /^\d{6}$/;
/** Cantidad de códigos de recuperación que se entregan al activar o regenerar. */
export const RECOVERY_CODE_COUNT = 10;
/** Caracteres de cada código de recuperación (sin contar el guion). */
export const RECOVERY_CODE_LENGTH = 10;
/** Tamaño de cada grupo del código de recuperación al mostrarlo: «ABCDE-FGHJK». */
export const RECOVERY_CODE_GROUP_LENGTH = 5;
/**
 * Alfabeto de los códigos de recuperación: sin 0/O, 1/I/L para que se puedan
 * copiar a mano desde un papel sin confusiones.
 */
export const RECOVERY_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
/** Patrón de un código de recuperación ya normalizado (sin guiones ni espacios). */
export const RECOVERY_CODE_PATTERN = new RegExp(`^[${RECOVERY_CODE_ALPHABET}]{${String(RECOVERY_CODE_LENGTH)}}$`);
/** Separadores que el usuario puede escribir dentro de un código de recuperación. */
const RECOVERY_CODE_SEPARATORS = /[\s-]/g;
/** Normaliza un código de recuperación escrito por el usuario: mayúsculas, sin espacios ni guiones. */
export function normalizeRecoveryCode(input) {
    return input.replace(RECOVERY_CODE_SEPARATORS, '').toUpperCase();
}
/** Da formato de lectura a un código de recuperación: «ABCDEFGHJK» → «ABCDE-FGHJK». */
export function formatRecoveryCode(code) {
    const normalized = normalizeRecoveryCode(code);
    return `${normalized.slice(0, RECOVERY_CODE_GROUP_LENGTH)}-${normalized.slice(RECOVERY_CODE_GROUP_LENGTH)}`;
}
/**
 * Roles que por defecto deben usar verificación en dos pasos: quienes
 * configuran la institución, mueven dinero de la agencia o ven toda la
 * cartera y la bitácora (administración, gerencia, cumplimiento y auditoría).
 */
export const DEFAULT_TWO_FACTOR_REQUIRED_ROLES = ['admin', 'manager', 'compliance', 'auditor'];
/** Política de seguridad inicial. */
export function defaultSecuritySettings() {
    return { twoFactorRequiredRoles: [...DEFAULT_TWO_FACTOR_REQUIRED_ROLES] };
}
/** ¿La política de la institución obliga a este rol a usar la verificación en dos pasos? */
export function requiresTwoFactor(role, security) {
    return (security?.twoFactorRequiredRoles ?? DEFAULT_TWO_FACTOR_REQUIRED_ROLES).includes(role);
}
//# sourceMappingURL=two-factor.js.map